import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';
import { ToastrService } from 'ngx-toastr';
import { Observable, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserapiService {

  constructor(private httpClient: HttpClient, private localstorage: LocalStorageService, private router: Router, private msg: ToastrService) { }
  async GET(endpoint: string): Promise<any> {
    
    return new Promise(async (resolve, reject) => {
      try {
        // endpoint = endpoint.replace("@user", "?userid=" + this.common.GetUser())

        let result = this.httpClient.get(UserapiService.getBookingURL() + endpoint, await this.buildRequestOptions())
          .pipe(timeout(50000));
        result.subscribe(async (response: any) => {

          resolve(response);
        },
          (err) => {
            console.log('Caught exception in GET request: ', err);
            reject(null);
            if (err.status == 401) {
              this.localstorage.clearAll();
              this.msg.error('Session Expired', "", { timeOut: 5000 });
              this.router.navigate(['/login']);
            }
            return;
          }
        );
      } catch (e) {
        console.log('Caught exception in GET request: ', e);
        reject(null);
        return;
      }
    });
  }

  /**
     * Perform a post request to the server.
     */
  async GetBody(endpoint: string, data: any = null, withTimeout = true): Promise<any> {
    
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.post(UserapiService.getBookingURL() + endpoint, data, await this.buildRequestOptions()).pipe(timeout(withTimeout ? 15000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in POST request: ', e);
        reject(null);
        return;
      }
    });
  }

  /**
     * Perform a post request to the server.
     */
  async POST(endpoint: string, data: any = null, withTimeout = true): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.post(UserapiService.getBookingURL() + endpoint, data, await this.buildRequestOptions()).pipe(timeout(withTimeout ? 15000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in POST request: ', e);
        reject(null);
        return;
      }
    });
  }

  async POSTFORM(endpoint: string, data: any = null, withTimeout = true): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let result: Observable<any>;
      try {
        result = await this.httpClient.post(UserapiService.getBookingURL() + endpoint, data, await this.buildRequestOptions_form()).pipe(timeout(withTimeout ? 15000 : 60000));
        result.subscribe(async (response: any) => {
          resolve(response);
          return;
        });
      } catch (e) {
        console.log('Caught exception in POST request: ', e);
        reject(null);
        return;
      }
    });
  }

  private static getBookingURL() {
    return environment.apiurl + "user/";
  }
  /**
    * Genearate the request options for all httpclient call.
    */
  private async buildRequestOptions() {
    let options = { headers: await this.buildHeaders() };
    return options;
  }
  private async buildRequestOptions_form() {
    let options = { headers: await this.buildHeaders_form() };
    return options;
  }
  /**
    * Generate the headers that are required for all the requests.
    */
  private async buildHeaders() {
    var token = localStorage.getItem("GuestToken")

    if (token) {
      token = token.replace(/^"(.*)"$/, '$1'); // Remove quotes from token start/end. This is a temp fix?!
    }
    let headers = new HttpHeaders({
      'Content-Type': environment.content_type,
      'Authorization': 'Bearer ' + token
    });
    return headers;
  }
  private async buildHeaders_form() {
    var token = localStorage.getItem("GuestToken")

    if (token) {
      token = token.replace(/^"(.*)"$/, '$1'); // Remove quotes from token start/end. This is a temp fix?!
    }
    let headers = new HttpHeaders({
      //'Content-Type':  environment.content_type,
      'Authorization': 'Bearer ' + token
    });
    return headers;
  }

}
